// src/components/ui/forms/PartnerCodeInput/PartnerCodeInput.jsx
import React from 'react';
import { KeyRound } from 'lucide-react';
import Input from '../Input/Input';
import { cn } from '../../../../utils/cn';

const PartnerCodeInput = ({
  value,
  onChange,
  placeholder = "ABC-12345",
  maxLength = 9,
  className = '',
  ...props
}) => {
  // Format partner code as XXX-XXXXX
  const formatPartnerCode = (inputValue) => {
    // Remove any non-alphanumeric characters and convert to uppercase
    const cleaned = inputValue.replace(/[^A-Z0-9]/gi, '').toUpperCase();
    
    // Format as XXX-XXXXX
    if (cleaned.length <= 3) {
      return cleaned;
    } else {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 8)}`;
    }
  };

  const handleChange = (e) => {
    const formatted = formatPartnerCode(e.target.value);
    
    // Create a new event object with the formatted value
    const formattedEvent = {
      ...e,
      target: {
        ...e.target,
        value: formatted
      }
    };
    
    onChange(formattedEvent);
  };

  return (
    <Input
      type="text"
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      maxLength={maxLength}
      leftIcon={KeyRound}
      className={cn(
        // Partner code specific styling
        "text-center font-mono text-lg tracking-wider",
        className
      )}
      {...props}
    />
  );
};

export default PartnerCodeInput;